import { ofType } from 'redux-observable';
import { from, of } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';

import { Epic } from 'models/meta/epic';

import { fetchSupportedCurrenciesFailure, fetchSupportedCurrenciesSuccess } from 'store/supported-currencies/actions';
import { FETCH_SUPPORTED_CURRENCIES } from 'store/supported-currencies/actions.types';


export const onFetchSupportedCurrencies: Epic = (action$, state$, { beneficiaries }) => action$.pipe(
    ofType(FETCH_SUPPORTED_CURRENCIES),
    switchMap(({ payload }) => from(beneficiaries.fetchSupportedCurrencies(payload?.queryParams)).pipe(
        switchMap((response) => of(fetchSupportedCurrenciesSuccess({
            items: response.data?.length > 0
                ? response.data.map((currency) => ({
                    fullName: currency.name,
                    short: currency.iso,
                    symbol: currency.symbol,
                }))
                : response.data,
            totalCount: response?.data?.length,
            locationPathname: payload?.locationPathname,
        }))),
        catchError(() => of(fetchSupportedCurrenciesFailure(payload?.locationPathname))),
    )),
);


export default [
    onFetchSupportedCurrencies,
];
